var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vector2i, GetEntries, E } from "js-vextensions";
import { Button, Column, Pre, Row, RowLR, Select, Spinner } from "react-vcomponents";
import { BaseComponentPlus } from "react-vextensions";
import { UpdateMapObject } from "Server/Commands/UpdateMapObject";
import { GetMapObject } from "Store/firebase/mapObjects";
import { DistanceUnit, ShapeType } from "Store/firebase/mapObjects/Components/@ShapeComp";
import { ToolUI } from "./Tool";
import { store } from "Store";
import { Observer } from "vwebapp-framework";
import { runInAction } from "mobx";
import { ShapeDrawer } from "../@Shared/ShapeDrawer";
import { MapObjectUI } from "../MapObjectUI";
let DrawShape = 
// todo: maybe rename to RedrawShape
class DrawShape extends ToolUI({}, {}) {
    render() {
        const targetObject = GetMapObject(store.main.write.tools.drawShape.targetObject);
        const minLineLength = store.main.write.tools.addObject.minLineLength;
        const minLineLengthUnit = store.main.write.tools.addObject.minLineLengthUnit;
        if (targetObject == null)
            return React.createElement("div", null);
        const splitAt = 110;
        return (React.createElement(Column, null, [ShapeType.Path, ShapeType.Region].Contains(targetObject.shape.type)
            && React.createElement(RowLR, { mt: 5, splitAt: splitAt },
                React.createElement(Pre, null, "Min line length: "),
                React.createElement(Row, { style: { width: "100%" } },
                    React.createElement(Spinner, { step: .01, style: { minWidth: 0 }, value: minLineLength, onChange: val => {
                            runInAction("DrawShape.minLineLength.onChange", () => store.main.write.tools.addObject.minLineLength = val);
                        } }),
                    React.createElement(Select, { options: GetEntries(DistanceUnit), value: minLineLengthUnit, onChange: val => {
                            runInAction("DrawShape.minLineLengthUnit.onChange", () => store.main.write.tools.addObject.minLineLengthUnit = val);
                        } })))));
    }
    Scene_OnMouseDown(e) {
        if (e.button != 0)
            return;
        const targetObject = GetMapObject(store.main.write.tools.drawShape.targetObject);
        const minLineLength = store.main.write.tools.addObject.minLineLength;
        const minLineLengthUnit = store.main.write.tools.addObject.minLineLengthUnit;
        if (targetObject == null)
            return;
        this.shapeDrawer = new ShapeDrawer();
        this.shapeDrawer.InitContext({ mapScene: this.MapScene, objPosition: targetObject.position });
        this.shapeDrawer.InitToolProps({ minLineLength, minLineLengthUnit });
        this.shapeDrawer.CreateNewShape(targetObject.shape, this.MapScene.MousePos_Canvas(new Vector2i(e.pageX, e.pageY)));
        this.MapScene.Update();
        this.MapScene.UpdateMapObjectUI(targetObject._key); // re-render map-object-ui for selected obj, causing old shape to be hidden (if any), while we're drawing new one
        return true;
    }
    Scene_OnMouseMove(e) {
        if (!this.shapeDrawer)
            return;
        this.shapeDrawer.UpdateNewShape(this.MapScene.MousePos_Canvas(new Vector2i(e.pageX, e.pageY)));
        this.MapScene.Update();
        return true;
    }
    Scene_OnMouseUp(e) {
        if (e.button != 0)
            return;
        if (!this.shapeDrawer)
            return;
        const targetObject = GetMapObject(store.main.write.tools.drawShape.targetObject);
        this.shapeDrawer.UpdateNewShape(this.MapScene.MousePos_Canvas(new Vector2i(e.pageX, e.pageY)));
        new UpdateMapObject({ id: targetObject._key, updates: { shape: this.shapeDrawer.shape } }).Run();
        this.shapeDrawer = null;
        this.MapScene.Update();
        runInAction("DrawShape.Scene_OnMouseUp", () => store.main.write.selectedTool = null);
        return true;
    }
    RenderInScene() {
        const targetObject = GetMapObject(store.main.write.tools.drawShape.targetObject);
        return this.shapeDrawer
            && React.createElement(MapObjectUI, { obj: targetObject.Extended({ shape: this.shapeDrawer.shape }), mapScene: this.MapScene, worldViewArea: this.MapScene.WorldViewArea() });
    }
    RenderForObject(obj, extraInfo) {
        const targetObject = GetMapObject(store.main.write.tools.drawShape.targetObject);
        if (obj == targetObject && this.shapeDrawer) {
            extraInfo.cancelNormalRender = true;
        }
        return null;
    }
};
DrawShape = __decorate([
    Observer
    // todo: maybe rename to RedrawShape
], DrawShape);
export { DrawShape };
let ShapeSelectButton = class ShapeSelectButton extends BaseComponentPlus({}, {}) {
    render() {
        const { shape, text, title } = this.props;
        const selectedShape = store.main.write.tools.addObject.shape;
        const selected = selectedShape == shape;
        return (React.createElement(Button, { text: text || ShapeType[shape], title: title || (text ? ShapeType[shape] : null), style: E(selected && { backgroundColor: "rgba(90,100,110,.8)" }), onClick: () => {
                runInAction("ShapeSelectButton.onClick", () => store.main.write.tools.addObject.shape = shape);
            } }));
    }
};
ShapeSelectButton = __decorate([
    Observer
], ShapeSelectButton);
export { ShapeSelectButton };
